import {
  DataTableDataSearchDto,
  DataTableFooterSearchDto,
  FooterDataDtoResponse,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../../utils/errors';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { portalGatewayClient } from '../portalGatewayClient';

export type FetchFooterDataQueryKey = readonly [
  widgetId: string,
  pageFilterSelections: DataTableDataSearchDto['selection'],
  tableFilterSelections: DataTableDataSearchDto['selection'],
  aggregationTypes: DataTableFooterSearchDto['aggregationTypes'],
  ...string[],
];
export const fetchFooterData: QueryFunction<
  FooterDataDtoResponse,
  QueryKeyWithRole<FetchFooterDataQueryKey>
> = async ({ queryKey }) => {
  const [
    widgetId,
    pageFilterSelections,
    tableFilterSelections,
    aggregationTypes,
  ] = unwrapQueryKeyWithRole(queryKey).params;

  const response = await portalGatewayClient.table.getFooterData(widgetId, {
    selection: { ...pageFilterSelections, ...tableFilterSelections },
    aggregationTypes,
  });

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error) || 'Error fetching footer data',
      response.status
    );
  }

  return response.data;
};
